import { GetPreviewModeOptions } from '../analytics-context-types';
import { getModalTag, getPODProductTag } from './utils';

export const getClickPreviewModeTag = (options: GetPreviewModeOptions) => {
  const { product } = getPODProductTag(
    options.productName,
    options.productID,
    options.productType,
    options.productQuantity,
  );

  const PreviewModeModalEvent = [
    {
      eventInfo: {
        eventName: 'area',
        eventAction: options.elementPosition,
      },
    },
    {
      eventInfo: {
        eventName: `view ${options.elementPosition}`,
        eventAction: options.button,
      },
    },
  ];

  const { modal, user } = getModalTag(options.productType, 'Preview Mode', PreviewModeModalEvent, options.projectID);

  return {
    modal,
    product,
    user,
  };
};
